/**
 * Vuex getters for the editor module.
 *
 * @module store/modules/editor/getters
 */
import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { EditorState } from "./types";
import { flowSectionsTitle, formatFlowSection } from "@/helperMethods/editor";

const getters: GetterTree<EditorState, RootState> = {
  /**
   * Gets the content node update flag.
   *
   * @param {EditorState} state - Module state
   * @returns {boolean} Update flag
   */
  updateContentNode(state, getters, rootState) {
    return state.updateContentNode;
  },

  /**
   * Gets the content node refetch flag.
   *
   * @param {EditorState} state - Module state
   * @returns {boolean} Refetch flag
   */
  refetchContentNodes(state, getters, rootState) {
    return state.refetchContentNodes;
  },

  /**
   * Gets flow sections with titles from flow editor.
   *
   * @param {EditorState} state - Module state
   * @param {any} getters - Getters object
   * @param {RootState} rootState - Root state
   * @returns {any} Flow sections with titles
   */
  flowSectionsTitle(state, getters, rootState) {
    return flowSectionsTitle(rootState.floweditor.flows);
  },

  /**
   * Gets flow sections mapped by first question ID.
   *
   * @param {EditorState} state - Module state
   * @param {any} getters - Getters object
   * @param {RootState} rootState - Root state
   * @returns {any} Formatted flow sections array
   */
  flowSectionsByFirstQuestionId(state, getters, rootState) {
    const flowSections = flowSectionsTitle(rootState.floweditor.flows);
    const formattedToQuestionIdArray = formatFlowSection(flowSections);
    return formattedToQuestionIdArray;
  },

  /**
   * Gets trigger differences for version tracking.
   *
   * @param {EditorState} state - Module state
   * @returns {Object} Trigger diff by custom identifier and node ID
   */
  triggerDiff(state, getters, rootState) {
    return state.triggerDiff;
  },

  /**
   * Gets connected nodes analysis state and data.
   *
   * @param {EditorState} state - Module state
   * @returns {Object} Connected nodes with busy flag and data
   */
  connectedNodes(state) {
    return state.connectedNodes;
  },
};

export default getters;
